export const SERVER_URL = "http://localhost:8080/graphql"; // <-- add this line when deployed
//export const SERVER_URL = "/graphql"; // <-- add this line when deployed
export default SERVER_URL;
